export default __webpack_public_path__ + "static/media/Dudas-orange.c84df778.svg";